<api-token-section>
    <div class="bg-admin2">
            <div class="flex items-center justify-between mb-2">
                <h2 class="card-title text-xl text-accent" if="{!props || props.setup !== 'true'}">{locale?.t('admin_apitoken_title')}</h2>
                <button
                    if="{state.userRole === 'SYSTEM_ADMIN'}"
                    class="btn btn-sm btn-outline"
                    onclick="{openLaunchTokenTester}"
                    title="{locale?.t('admin_apitoken_testlaunchtokens')}">
                    <i class="icon-metalark-edit-note"></i>
                    {locale?.t('admin_apitoken_launchtokentester')}
                </button>
            </div>
            <p class="text-sm mb-4 font-medium">
                {locale?.t('admin_apitoken_subtitle')}
            </p>

            <!-- Feature Restricted Message for Trial Accounts -->
            <div if="{!state.featureFlags.api_token_generation}" class="alert bg-amber-50 border-2 border-amber-400 text-amber-900 mb-4">
                <i class="icon-metalark-lock text-amber-700"></i>
                <div>
                    <h3 class="font-bold text-amber-900">{locale?.t('admin_apitoken_unavailable_title')}</h3>
                    <p class="text-sm mt-1 text-amber-800">
                        {locale?.t('admin_apitoken_unavailable_message')}
                    </p>
                </div>
            </div>

            <!-- Generation Form -->
            <div class="flex flex-col gap-4 mt-2" if="{!state.generatedToken && state.featureFlags.api_token_generation}">
                <div class="form-control">
                    <label for="api-token-section-desc" class="label font-bold text-accent mb-2 w-full flex flex-col gap-0">
                        <span class="label-text w-full inline mb-1">
                            {locale?.t('admin_apitoken_description_label')} <span class="text-error">*</span>
                        </span>
                        <span class="w-full label-text-alt text-gray-500 font-medium text-sm inline">
                            {locale?.t('admin_apitoken_description_hint')}
                        </span>
                    </label>
                    <input id="api-token-section-desc"
                        type="text"
                        disabled="{props.off}"
                        placeholder="{locale?.t('admin_apitoken_description_placeholder')}"
                        class="input input-bordered w-full mb-4"
                        value="{state.description}"
                        oninput="{handleDescriptionChange}"
                        maxlength="100" />
                </div>

                <div class="form-control">
                    <label for="api-token-section-expdate" class="label font-bold text-accent mb-2 w-full flex flex-col gap-0">
                        <span class="label-text w-full inline mb-1">
                            {locale?.t('admin_apitoken_expiration_label')} <span class="text-error">*</span>
                        </span>
                        <span class="w-full label-text-alt text-gray-500 font-medium text-sm inline">
                            {locale?.t('admin_apitoken_expiration_hint')}
                        </span>
                    </label>
                    <input id="api-token-section-expdate"
                        type="date"
                        disabled="{props.off}"
                        class="input input-bordered"
                        value="{state.expirationDate}"
                        min="{state.minDate}"
                        max="{state.maxDate}"
                        onchange="{handleDateChange}" />
                </div>

                <div class="flex gap-2 mt-3">
                    <button
                        class="btn btn-primary"
                        onclick="{generateToken}"
                        disabled="{state.loading || !isFormValid() || props.off}">
                        <i class="icon-metalark-key me-1" if="{!state.loading}"></i>
                        <span class="loading loading-spinner loading-sm" if="{state.loading}"></span>
                        {state.loading ? locale?.t('admin_apitoken_generating') : locale?.t('admin_apitoken_generate')}
                    </button>
                </div>

                <div class="alert alert-info" if="{state.error}">
                    <i class="icon-metalark-info"></i>
                    <span>{state.error}</span>
                </div>
            </div>

            <!-- Generated Token Display -->
            <div class="flex flex-col gap-4" if="{state.generatedToken}">
                <div class="alert alert-warning">
                    <i class="icon-metalark-warning"></i>
                    <div>
                        <h3 class="font-bold">{locale?.t('admin_apitoken_warning_title')}</h3>
                        <div class="text-sm mt-1">
                            {locale?.t('admin_apitoken_warning_message')}
                        </div>
                    </div>
                </div>

                <div class="form-control">
                    <label class="label" for="api-token-section-key">
                        <span class="label-text font-semibold text-accent">{locale?.t('admin_apitoken_yourkey')}</span>
                    </label>
                    <div class="flex gap-2">
                        <input id="api-token-section-key"
                            disabled="{props.off}"
                            type="{state.showToken ? 'text' : 'password'}"
                            class="input input-bordered flex-1 font-mono text-sm"
                            value="{state.generatedToken}"
                            readonly />
                        <button
                            class="btn btn-square btn-outline"
                            onclick="{toggleTokenVisibility}"
                            title="{state.showToken ? locale?.t('admin_apitoken_hide') : locale?.t('admin_apitoken_show')} token"
                            aria-label="{state.showToken ? locale?.t('admin_apitoken_hide') : locale?.t('admin_apitoken_show')}">
                            <i class="icon-metalark-{state.showToken ? 'eye-off' : 'eye'}"></i>
                        </button>
                        <button
                            class="btn btn-square btn-primary"
                            onclick="{copyToClipboard}"
                            title="{locale?.t('admin_apitoken_copy')}"
                            aria-label="{locale?.t('admin_apitoken_copy')}">
                            <i class="icon-metalark-{state.copied ? 'check' : 'copy'}"></i>
                        </button>
                    </div>
                    <label class="label">
                        <span class="label-text-alt text-success" if="{state.copied}">
                            ✓ {locale?.t('admin_apitoken_copied')}
                        </span>
                    </label>
                </div>

                <div class="stats shadow">
                    <div class="stat">
                        <div class="stat-title text-accent">{locale?.t('admin_apitoken_stat_description')}</div>
                        <div class="stat-value text-base">{state.tokenMetadata.description}</div>
                    </div>
                    <div class="stat">
                        <div class="stat-title text-accent">{locale?.t('admin_apitoken_stat_expiresat')}</div>
                        <div class="stat-value text-base">{tools?.formatDateTime(state.tokenMetadata.expiresAt)}</div>
                    </div>
                    <div class="stat">
                        <div class="stat-title text-accent">{locale?.t('admin_apitoken_stat_sliceid')}</div>
                        <div class="stat-value text-sm font-mono">{state.tokenMetadata.sliceId}</div>
                    </div>
                </div>

                <div class="flex gap-2">
                    <button
                        class="btn btn-outline"
                        onclick="{reset}">
                        {locale?.t('admin_apitoken_generateanother')}
                    </button>
                </div>
            </div>
    </div>

    <!-- Launch Token Tester Modal -->
    <launch-token-tester-modal
        isOpen="{state.launchTokenTesterOpen}"
        onClose="{closeLaunchTokenTester}"
    />

    <script>
        import { getApi, getFeatureFlagService } from '../../../services/service-loader';
        import launchTokenTesterModal from '../launch-token-tester-modal.tag';

        export default {
            get components() {
                return { launchTokenTesterModal };
            },

            state: {
                description: 'API Key',
                expirationDate: '',
                minDate: '',
                maxDate: '',
                loading: false,
                error: null,
                generatedToken: null,
                tokenMetadata: null,
                showToken: false,
                copied: false,
                featureFlags: {},
                launchTokenTesterOpen: false,
                userRole: null
            },

            async onMounted() {
                await this.loadFeatureFlags();
                await this.loadUserRole();

                // Calculate default date (90 days from now)
                const now = new Date()
                const defaultDate = new Date(now)
                defaultDate.setDate(defaultDate.getDate() + 90)
                
                // Calculate min date (tomorrow)
                const minDate = new Date(now)
                minDate.setDate(minDate.getDate() + 1)
                
                // Calculate max date (365 days from now)
                const maxDate = new Date(now)
                maxDate.setDate(maxDate.getDate() + 365)
                
                this.update({
                    expirationDate: this.formatDateForInput(defaultDate),
                    minDate: this.formatDateForInput(minDate),
                    maxDate: this.formatDateForInput(maxDate)
                })
            },
            
            async loadFeatureFlags() {
                try {
                    const featureFlagService = await getFeatureFlagService();
                    const response = await featureFlagService.getActiveFlags();
                    const flags = response.flags;
                    this.update({ featureFlags: flags });
                    console.log('[ApiTokenSection] Loaded feature flags:', flags);
                    console.log('[ApiTokenSection] api_token_generation enabled:', flags.api_token_generation);
                } catch (error) {
                    console.error('[ApiTokenSection] Failed to load feature flags:', error);
                    this.update({ featureFlags: {} });
                }
            },

            async loadUserRole() {
                try {
                    // Get user context from tools
                    const userContext = await this.tools?.getUserContext?.();
                    const role = userContext?.role;
                    this.update({ userRole: role });
                    console.log('[ApiTokenSection] User role:', role);
                } catch (error) {
                    console.error('[ApiTokenSection] Failed to load user role:', error);
                }
            },

            formatDateForInput(date) {
                // Format as YYYY-MM-DD for input[type="date"]
                return date.toISOString().split('T')[0]
            },

            handleDescriptionChange(e) {
                this.update({ 
                    description: e.target.value,
                    error: null
                })
            },

            handleDateChange(e) {
                let value = e.target.value

                if (value) {
                    const selected = new Date(value)
                    const max = new Date(this.state.maxDate)
                    const min = new Date(this.state.minDate)

                    if (selected > max) {
                        value = this.state.maxDate
                        e.target.value = value
                    } else if (selected < min) {
                        value = this.state.minDate
                        e.target.value = value
                    }
                }

                this.update({
                    expirationDate: value,
                    error: null
                })
            },

            isFormValid() {
                return this.state.description.trim().length > 0 && 
                       this.state.expirationDate.length > 0
            },

            calculateExpirationDays() {
                const now = new Date()
                now.setHours(0, 0, 0, 0)
                const expiration = new Date(this.state.expirationDate)
                const diffTime = expiration - now
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                return diffDays
            },

            async generateToken() {
                if (!this.isFormValid()) return

                this.update({ loading: true, error: null })

                try {
                    const expirationDays = this.calculateExpirationDays()

                    if (expirationDays < 1) {
                        throw new Error(this.locale.t('admin_apitoken_error_future'))
                    }

                    if (expirationDays > 365) {
                        throw new Error(this.locale.t('admin_apitoken_error_maxdays'))
                    }

                    console.log('Generating API token:', {
                        description: this.state.description,
                        expirationDays
                    })

                    const api = await getApi();
                    const response = await api.post('/auth/tokens/generate', {
                        description: this.state.description,
                        expirationDays: expirationDays
                    })

                    console.log('Token generated successfully:', response.data)

                    this.update({
                        generatedToken: response.data.token,
                        tokenMetadata: {
                            description: response.data.description,
                            expiresAt: response.data.expiresAt,
                            sliceId: response.data.sliceId,
                            type: response.data.type
                        },
                        loading: false,
                        error: null
                    })

                } catch (error) {
                    console.error('Failed to generate API token:', error)
                    this.update({
                        loading: false,
                        error: error.response?.data?.message || error.message || this.locale.t('admin_apitoken_error_failed')
                    })
                }
            },

            toggleTokenVisibility() {
                this.update({ showToken: !this.state.showToken })
            },

            async copyToClipboard() {
                try {
                    await navigator.clipboard.writeText(this.state.generatedToken)
                    this.update({ copied: true })
                    
                    // Reset copied state after 2 seconds
                    setTimeout(() => {
                        this.update({ copied: false })
                    }, 2000)
                } catch (error) {
                    console.error('Failed to copy to clipboard:', error)
                    // Fallback for older browsers
                    const textarea = document.createElement('textarea')
                    textarea.value = this.state.generatedToken
                    textarea.style.position = 'fixed'
                    textarea.style.opacity = '0'
                    document.body.appendChild(textarea)
                    textarea.select()
                    document.execCommand('copy')
                    document.body.removeChild(textarea)
                    this.update({ copied: true })
                    setTimeout(() => {
                        this.update({ copied: false })
                    }, 2000)
                }
            },

            reset() {
                // Calculate new default date
                const now = new Date()
                const defaultDate = new Date(now)
                defaultDate.setDate(defaultDate.getDate() + 90)

                this.update({
                    description: '',
                    expirationDate: this.formatDateForInput(defaultDate),
                    generatedToken: null,
                    tokenMetadata: null,
                    showToken: false,
                    copied: false,
                    error: null
                })
            },


            openLaunchTokenTester() {
                console.log('[ApiTokenSection] Opening launch token tester modal');
                this.update({ launchTokenTesterOpen: true })
                console.log('[ApiTokenSection] Modal state updated to:', this.state.launchTokenTesterOpen);
            },

            closeLaunchTokenTester() {
                console.log('[ApiTokenSection] Closing launch token tester modal');
                this.update({ launchTokenTesterOpen: false })
            }
        }
    </script>
</api-token-section>